import type { FC } from 'react';
import React from 'react';
import { Typography } from '@mui/material';

interface TitleProps {
  children: string;
}

export const Title: FC<TitleProps> = ({ children }) => {
  return (
    <Typography
      variant="h6"
      sx={{
        fontWeight: 700,
        lineHeight: 1,
        mb: 2,
      }}
    >
      {children}
    </Typography>
  );
};
